import { DialogContent, DialogActions, Box } from '@mui/material';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { FormWrapper, Typo, GeneralInfo, SaveButton } from '../../styles';
import { useForm } from 'react-hook-form';
import { AddEducationModel } from '../../../../../../../interfaces/types/User';
import {
  useFieldsOfStudyQuery,
  useUniversityQuery,
} from '../../../../../../../rq/hooks/useQueries';
import { InputField } from '../../../../../InputField/InputField';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAddEducation } from '../../../../../../../rq/hooks/useEditProfile.mutation';
import { AddEducationSchema } from '../../../../../../../validators/EditProfile.validator';
import { months } from '../../monthYear';
import {
  BootstrapDialog,
  BootstrapDialogTitle,
} from '../../../../../../../../src/components/BootstrapDialog/BootstrapDialog';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { year } from '../../../../../../../static';
import Select from '../../../../../../../components/Select/Select';

export default function AddEducation({ open, setOpen, setItem }: any) {
  const { t } = useTranslation();
  const methods = useForm<AddEducationModel>({
    resolver: yupResolver(AddEducationSchema(t)),
  });
  const { data: universities = [] } = useUniversityQuery();
  const { data: fields_of_study = [] } = useFieldsOfStudyQuery();
  const {
    register,
    handleSubmit,
    formState: {
      errors: {
        description,
        educationId,
        fieldOfStudyId,
        startMonth,
        startYear,
      },
    },
  } = methods;
  //   react-mutation
  const { mutate: addEducation, isLoading } = useAddEducation();

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async (data: AddEducationModel) => {
    addEducation(data, {
      onSuccess: (res) => {
        setOpen(false);
        toast.success(t('successMessage.admin_verification'));
      },
    });
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
      >
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            {t('editProfile.edit_candidate_profile.education.title_add')}
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <FormWrapper>
              <div>
                <Typo>
                  {t('editProfile.edit_candidate_profile.general_info')}
                </Typo>
                <GeneralInfo>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ mr: 1 }}
                    error={!!educationId}
                  >
                    <InputLabel id="test-select-label">
                      {t(
                        'editProfile.edit_candidate_profile.education.university'
                      )}
                    </InputLabel>
                    <Select
                      defaultValue=""
                      options={universities}
                      variant="outlined"
                      input={
                        <OutlinedInput
                          label={t(
                            'editProfile.edit_candidate_profile.education.university'
                          )}
                        />
                      }
                      {...register('educationId')}
                      fieldError={educationId}
                    />
                  </FormControl>
                  <FormControl fullWidth size="small" error={!!fieldOfStudyId}>
                    <InputLabel id="test-select-label">Orientation</InputLabel>
                    <Select
                      defaultValue=""
                      options={fields_of_study}
                      variant="outlined"
                      input={<OutlinedInput label="Orientation" />}
                      {...register('fieldOfStudyId')}
                      fieldError={fieldOfStudyId}
                    />
                  </FormControl>
                </GeneralInfo>
              </div>
              <div>
                <Typo>
                  {t('editProfile.edit_candidate_profile.start_date')}
                </Typo>
                <GeneralInfo>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ mr: 1 }}
                    error={!!startMonth}
                  >
                    <InputLabel id="test-select-label">
                      {t('editProfile.edit_candidate_profile.month')}
                    </InputLabel>
                    <Select
                      defaultValue=""
                      options={months}
                      variant="outlined"
                      input={
                        <OutlinedInput
                          label={t('editProfile.edit_candidate_profile.month')}
                        />
                      }
                      {...register('startMonth')}
                      fieldError={startMonth}
                    />
                  </FormControl>

                  <FormControl fullWidth size="small" error={!!startYear}>
                    <InputLabel id="test-select-label">
                      {t('editProfile.edit_candidate_profile.year')}
                    </InputLabel>
                    <Select
                      defaultValue=""
                      options={year()}
                      variant="outlined"
                      input={
                        <OutlinedInput
                          label={t('editProfile.edit_candidate_profile.year')}
                        />
                      }
                      {...register('startYear')}
                      fieldError={startYear}
                    />
                  </FormControl>
                </GeneralInfo>
              </div>
              <div>
                <Typo>{t('editProfile.edit_candidate_profile.end_date')}</Typo>
                <GeneralInfo>
                  <FormControl fullWidth size="small" sx={{ mr: 1 }}>
                    <InputLabel id="test-select-label">
                      {t('editProfile.edit_candidate_profile.month')}
                    </InputLabel>
                    <Select
                      defaultValue=""
                      options={months}
                      variant="outlined"
                      input={
                        <OutlinedInput
                          label={t('editProfile.edit_candidate_profile.month')}
                        />
                      }
                      {...register('endMonth')}
                    />
                  </FormControl>

                  <FormControl fullWidth size="small">
                    <InputLabel id="test-select-label">
                      {t('editProfile.edit_candidate_profile.year')}
                    </InputLabel>
                    <Select
                      defaultValue=""
                      options={year()}
                      variant="outlined"
                      input={
                        <OutlinedInput
                          label={t('editProfile.edit_candidate_profile.year')}
                        />
                      }
                      {...register('endYear')}
                    />
                  </FormControl>
                </GeneralInfo>
              </div>

              <Typo>{t('editProfile.edit_candidate_profile.description')}</Typo>
              <InputField
                multiline
                fullWidth
                size="small"
                fieldError={description}
                {...register('description')}
              />
            </FormWrapper>
          </DialogContent>
          <DialogActions>
            <SaveButton
              loading={isLoading}
              variant="contained"
              type="submit"
              autoFocus
            >
              {t('editProfile.edit_candidate_profile.save')}
            </SaveButton>
          </DialogActions>
        </Box>
      </BootstrapDialog>
    </div>
  );
}
